import { ReactNode } from "react"

export type PillVariant =
  | "gray"
  | "red"
  | "yellow"
  | "green"
  | "blue"
  | "indigo"
  | "purple"
  | "pink"
  | "orange"
  | "amber"

interface PillProps {
  className?: string
  variant: PillVariant
  children: ReactNode
}

export const Pill = ({ className, variant, children }: PillProps) => {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-${variant}-100 text-${variant}-800 ${className}`}
    >
      {children}
    </span>
  )
}
